import logoLightMode from '../../assets/images/logo-light-mode.svg';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import { Col, Row } from 'react-bootstrap';
import { useAuth } from '../../hooks/context/useAuth';


export default function AccessDenied() {
  const { logout } = useAuth();
  return (
    <div className='vh-100 d-flex flex-column user-select-none align-items-center justify-content-center text-center'>
      <p className="not-found-bg">403</p>
      <img src={logoLightMode} alt="Cypherleak" />
      <h1 className='display-3 fw-bold text-dark mt-3'>Access denied</h1>
      <h4 className='fw-light text-dark text-wrap text-md'>
        You don't have permissions to access this page.<br />
        <span className='text-green text-decoration-underline'>Contact an administrator</span> to get permissions or try to login
        <br />with another account
      </h4>
      <Row className='mt-4'>
        <Col>
          <PrimaryButton rest={{ className: 'px-5 py-2 bg-gray' }}>
            <span className='h6 my-2 fw-normal'> Contact </span>
          </PrimaryButton>
        </Col>
        <Col>
          <PrimaryButton rest={{ className: 'px-5 py-2', onClick: logout }}>
            <span className='h6 my-2 fw-normal'> Login </span> <i className="icon-arrow-light-blanc" />
          </PrimaryButton>
        </Col>
      </Row>
    </div>
  );
}
  